import { OFFER_DOCUMENT_VERSION, OFFER_LINK_KAZ, OFFER_LINK_RUS } from 'constants/links';

const getOfferHrefWithVersion = (locale: string): string => {
  const baseHref = locale === 'ru' ? OFFER_LINK_RUS : OFFER_LINK_KAZ;

  if (!OFFER_DOCUMENT_VERSION) {
    return baseHref;
  }

  return `${baseHref}?v=${OFFER_DOCUMENT_VERSION}`;
};

export { getOfferHrefWithVersion };
